// src/Services/Profile.ts
import { api } from "./Api";
import { toast } from "react-toastify";
import { Logout } from "../Components/Auth/isAuthenticated";
import { getApiErrorMessage } from "./apiError";

const auth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

export interface IProfileAddress {
  postalCode: string;
  street: string;
  number: string;
  complement?: string;
  district: string;
  city: string;
  state: string;
  stateShort?: string;
  country?: string;
}

export interface IProfile {
  fullName: string;
  nickname: string;
  cargo: string;
  birthDate: string;
  email: string;
  phone: string;
  city: string;
  state: string;
  country: string;
  nativeLanguage: string;
  instagram: string | null;
  site: string | null;
  address: IProfileAddress;
}

// GET não usa toast.promise — carrega silenciosamente e trata falha real.
export const getMyProfile = async () => {
  try {
    return await api.get("/pt_BR/establishment/profile", auth());
  } catch (error) {
    if ((error as any)?.response?.status === 401) {
      Logout();
    } else {
      toast.error(getApiErrorMessage(error, "Não foi possível carregar o perfil."));
    }
    throw error;
  }
};

export const updateMyProfile = async (data: Partial<IProfile>) => {
  return toast.promise(
    api.put("/pt_BR/establishment/profile", data, auth()),
    {
      pending: "Salvando informações...",
      success: "Informações salvas com sucesso.",
      error: {
        render({ data: error }) {
          return getApiErrorMessage(
            error,
            "Não foi possível salvar as informações. Por favor, tente novamente.",
          );
        },
      },
    },
  );
};

export const changePassword = async (data: {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}) => {
  return toast.promise(
    api.put("/pt_BR/establishment/profile/password", data, auth()),
    {
      pending: "Alterando senha...",
      success: "Senha alterada com sucesso.",
      error: {
        render({ data: error }) {
          return getApiErrorMessage(error, "Erro ao alterar senha.");
        },
      },
    },
  );
};

export const deleteMyAccount = async (password: string) => {
  return toast.promise(
    api.delete("/pt_BR/establishment/account", {
      ...auth(),
      data: { password },
    }),
    {
      pending: "Excluindo conta...",
      success: "Conta excluída com sucesso.",
      error: {
        render({ data: error }) {
          return getApiErrorMessage(error, "Erro ao excluir conta.");
        },
      },
    },
  );
};